// extracted by mini-css-extract-plugin
export default {"verticalLine":"tagList_verticalLine__M7xFl"};